import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export default function Unauthorized() {
  return (
    <div className="page">
      <h1>Access Denied</h1>
      <p>You do not have permission to access this page.</p>
      <p>
        If you believe this is an error, contact your club administrator
        or a Global Admin for access.
      </p>
      <button className="btn" onClick={() => signOut(auth)}>
        Sign out
      </button>
    </div>
  );
}
